<template>
  <div>
    <div style="margin-bottom: 20px;margin-top: 30px">
      <router-view></router-view>
      <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">绑定</el-button>
      <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDelete()">批量删除</el-button>
    </div>
    <div style="width:100%;">
      <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection"
               @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true"
               :table-col-check="{isShow:true,name:'-Permission2'}"
               :page="page" @pageChange="handlePagePagination" :isShowRowSelection="true">
        <template #companyname="{ record,index }">
          <ex-fold-cell :text="'companyName'" :record="record.company" :index="index" ></ex-fold-cell>
        </template>
        <template #salesManagername="{ record,index }">
          <ex-fold-cell :text="'name'" :record="record.salesManager" :index="index" ></ex-fold-cell>
        </template>
        <div slot="operation" slot-scope="{text,record}">
          <el-button size="mini" type="warning" @click="handleEdit(record)" class="opera">修改</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(record)">删除</el-button>
        </div>
      </w-table>
      <add-permission v-if="showAddEditDialog" :show-permission-dialog="showAddEditDialog" :selectType="selectType"
                              :select-detail="selectDetail" @submit="closeAddEditCusDialog">
      </add-permission>
      <picture-loading v-if="loading"></picture-loading>
    </div>
  </div>
</template>

<script>

import {permission} from "@/utils/data/tableCol/permission/permission";
import {deletePermission, getPermissionPage} from "@/api/dilivery/permission";
import AddPermission from "@/components/permission/AddPermission.vue";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldCell from "@/components/ExFoldCell.vue";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";

export default {
  name: "Permission",
  components: {PictureLoading, ExFoldCell, TableHeadNote, AddPermission},
  data() {
    return {
      ids: [],
      fixedcols: [],
      loading:true,
      searchConditionTag: [],//搜索tag
      sortConditionTag: [],
      tableData: [],
      showAddEditDialog: false, //控制编辑页面显示与隐藏
      selectDetail: '',
      selectType: {},
      page: {
        pageSize: 10,
        currentNum: 1,
        total: null
      },
      deleterInfo: {},
      showDeleteDialog: false,
    }
  },
  computed: {
    columns() {
      let cols = permission(this.searchConditionTag || {});
      if(this.fixedcols.length !== 0){
        cols.forEach(item => {
          if(this.fixedcols.includes(item.key)){
            item.fixed = 'left'
          }
        })
      }
      return JSON.parse(JSON.stringify(cols))
    }
  },
  mounted() {
    this.getData()
  },
  methods: {

    //表格的选择框
    rowSelection(selectedRows) {
      this.ids = selectedRows.map(item => item.id)
    },
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData('search')
    },
    // 获取数据
    getData(type) {
      this.loading =true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (type) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      this.sortConditionTag.forEach(item => {
        params["order"] = item.colName + "." + item.order
      })
      let sendData = {}
      sendData = this.getSearch(sendData)
      getPermissionPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      this.searchConditionTag.forEach(item => {
        sendData["query#" + item.key + ".LIKE"] = item.value
      })
      return sendData
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },

    //编辑添加表格信息
    handleEdit(row) {
      if (row !== undefined && row !== 'undefined') {
        this.selectDetail = row
        this.selectType = {
          type: 'edit',
        }
      } else {
        this.selectType = {
          type: 'add',
        }
        this.selectDetail = ''
      }
      this.showAddEditDialog = true
    },
    // 关闭编辑、增加弹出框
    closeAddEditCusDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() =>{
        this.showAddEditDialog = false
      })
    },

    //删除
    handleDelete(row) {
      let ids = []
      if (row && row.id) {
        ids.push(row.id)
      } else {
        if (this.ids.length > 0) {
          ids = this.ids
        } else {
          this.$messageUi.error('请勾选要批量删除的数据')
          return
        }
      }
      this.$confirmUi('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除
        let param = {
          "ids" : ids.join(',')
        }
        deletePermission(param).then(res => {
          if (res.code === 200) {
            this.$messageUi({
              type: 'success',
              message: '删除成功!'
            })
            this.ids = []
            const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize)
            this.page.currentNum = this.page.currentNum > totalPage ? totalPage : this.page.currentNum
            this.page.currentNum = this.page.currentNum < 1 ? 1 : this.page.currentNum
            this.getData()
          }
        }).catch(err => {
        })
      }).catch(() => {

      })
    }
  }
}
</script>

<style scoped>


</style>
